import { render } from "./Layout.vue?vue&type=template&id=14a472fc"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/configuration/Layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14a472fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14a472fc', __exports__)) {
    console.log('reload')
    api.reload('14a472fc', __exports__)
  }
  
  module.hot.accept("./Layout.vue?vue&type=template&id=14a472fc", () => {
    console.log('re-render')
    api.rerender('14a472fc', render)
  })

}


export default __exports__